import { watchFormFields } from '_forms.js';

// forEach polyfill
if ( window.NodeList && !NodeList.prototype.forEach ) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

const formTextInputs = document.querySelectorAll('.has-label-shift input[type="text"], .has-label-shift input[type="email"], .has-label-shift textarea');
const elementsToShow = document.querySelectorAll( '.animate' );
const header = document.getElementById('header');
const headerStickyWrap = document.getElementById('header_sticky_wrap');
let   headerTransitioning = false;

const scrollProps = {
	'scrollStatus' 					: null,
	'scrollPercentage' 			: null,
	'scrollDirection'				: null,
	'windowY'								: null,
	'lastKnownY'						: null,
	'directionReversedAt' 	: null,
	'distanceSinceReverse' 	: null,
	'compressesAt'					: 400,
	'unsticksAt'						: 500,
	'directionThreshold'		: 80
};

let scroll = window.requestAnimationFrame; // || function( callback ){ window.setTimeout( callback, 1000/60 ); }

const init = function() {

	loop();

};


/**
 *
 *
 *
 */
const loop = function() {

	updateScrollProps();

	if ( headerStickyWrap.classList.contains('js-compress-on-scroll') ) {
		compressOnScroll();
	}

  if ( headerStickyWrap.classList.contains('js-hide-on-scroll') ) {
		hideOnScroll();
	}

  watchFormFields( formTextInputs );
	watchForAnimationItems();
	topWatch();

	scroll( loop );

};


const watchForAnimationItems = function() {

	elementsToShow.forEach( ( element ) => {
		const baseClass = 'animated';
		if ( isElementInViewport( element ) ) {
			if ( element.classList.contains( baseClass ) ) {
				return;
			}
			element.classList.add( baseClass );
		}
	});

}


const updateScrollProps = function() {

	updateWindowY()
  updateScrollStatus()
	trackScrollReversal();

}


const updateWindowY = function() {

	const supportPageOffset = window.pageXOffset !== undefined;
	const isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
	const windowY = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;

	scrollProps.windowY = windowY;

}


const updateScrollStatus = function() {
	
	if ( scrollProps.windowY !== scrollProps.lastKnownY ) {
		if ( scrollProps.windowY > scrollProps.lastKnownY ) {
			if ( scrollProps.scrollDirection === 'up' ) scrollProps.directionReversedAt = scrollProps.windowY;
			scrollProps.scrollDirection = 'down';
		} else if ( scrollProps.windowY < scrollProps.lastKnownY ) {
			if ( scrollProps.scrollDirection === 'down' ) scrollProps.directionReversedAt = scrollProps.windowY;
			scrollProps.scrollDirection = 'up';
		}
		scrollProps.lastKnownY = scrollProps.windowY;
		scrollProps.scrollStatus = true;
	} else {
		scrollProps.scrollStatus = false;
	}

}


const trackScrollReversal = function() {

	if ( scrollProps.scrollDirection === 'down' ) {
		scrollProps.distanceSinceReverse = scrollProps.windowY - scrollProps.directionReversedAt;
	} else if ( scrollProps.scrollDirection === 'up' ) {
		scrollProps.distanceSinceReverse =  scrollProps.directionReversedAt - scrollProps.windowY;
	}

}


const compressOnScroll = function() {

	const reductionClass  = 'is-compressed';

	if ( scrollProps.windowY > scrollProps.compressesAt && !header.classList.contains(reductionClass) ) {
		header.classList.add( reductionClass )
	} else if ( scrollProps.windowY < scrollProps.compressesAt - header.offsetHeight && header.classList.contains(reductionClass) ) {
		header.classList.remove( reductionClass )
	}

}


const hideOnScroll = function() {

	const distance = 200;

  if ( headerTransitioning ) {
    return;
  }

	if ( scrollProps.windowY <= distance ) {
    headerStickyWrap.style.display = 'block';
    setTimeout( () => {
      headerStickyWrap.style.opacity = 1;  
      headerTransitioning = false;      
    }, 20 )
		return;
	}

	if ( scrollProps.distanceSinceReverse >= distance && scrollProps.scrollStatus ) {
    
		if ( scrollProps.scrollDirection === 'down' ) {
      headerTransitioning = true;
			headerStickyWrap.style.opacity = 0;
      setTimeout( () => {
        headerStickyWrap.style.top = '-9999px';
        headerTransitioning = false;
      }, 300 )
		}
	
		if ( scrollProps.scrollDirection === 'up' ) {
      headerTransitioning = true;
      headerStickyWrap.style.top = '0';
      setTimeout( () => {
        headerStickyWrap.style.opacity = 1;  
        headerTransitioning = false;      
      }, 20 )
		}

	}

};


const topWatch = function() {

	if ( !header ) return;

	const className = 'is-at-top';

	if ( scrollProps.windowY === 0 ) {
		document.body.classList.add( className );
	} else {
		document.body.classList.remove( className );
	}

}


const isElementInViewport = ( el ) => {

	var rect = el.getBoundingClientRect();

	return (
		( rect.top <= 0 && rect.bottom >= 0 )
		||
		( rect.bottom >= ( window.innerHeight || document.documentElement.clientHeight ) && rect.top <= ( window.innerHeight || document.documentElement.clientHeight ) )
		||
		( rect.top >= 0 && rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) )
	);

};


const api = {
	init: init
};

export default api;